import { Datagrid, ReferenceField, SimpleList, TextField } from 'react-admin';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';

export const UserList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <InfiniteList>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.userId}
                    secondaryText={record => record.name}
                    tertiaryText={record => record.phone}
                />
            ) : (
                <Datagrid>
                    <ReferenceField source="roleId" reference="roles">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="userId" />
                    <TextField source="name" />
                    <TextField source="phone" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
